if (window.ActiveXObject || 'ActiveXObject' in window) {
    require('@babel/polyfill')
  }
  
  require('./entry.js')
  